import { API_BASE, ODATA_BASE } from "helpers/api_config";
import { gorselYuklemeParametreleri } from "helpers/gorselKucult";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";



//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import { toastWarning } from "helpers/toast";
import { stripHtml } from "helpers/contentUtils";
import { MEDIA_BASE } from "helpers/api_config";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import jsPDF from "jspdf";
import "jspdf-autotable";

import CustomEditor from 'components/CustomEditor'; // Yolun doğruluğundan emin ol

import Dropzone from 'react-dropzone-uploader';
import { Base64 } from 'js-base64';
import moment from "moment";

import {
  getSong as onGetSong,
  addSong as onAddSong,
  updateSong as onUpdateSong,
  deleteSong as onDeleteSong,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";

import SayfaRehberi from "../../../components/Common/SayfaRehberi";
/** Dosya adini medya sunucusundaki tam adrese cevirir. */
const mediaUrl = value => {
  if (!value) return null;
  const name = String(value).trim();
  if (!name) return null;
  if (name.startsWith("http")) return name;
  return `${MEDIA_BASE}/${name.replace(/^\/+/, "")}`;
};

const ContactsList = props => {

  //meta title
  document.title = "ŞARKILAR | BERLİN ESNAF ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getFileName, setFileName] = useState('');
  const [getFileNameSecond, setFileNameSecond] = useState('');
  
  const [getHtmlDataLong, setHtmlDataLong] = useState();
 
  const [getFileSubMedia, setFileSubMedia] = useState([]);

  const [getSubMediaID, setSubMediaID] = useState();

  const [getFileSubMediaAdd, setFileSubMediaAdd] = useState([]);

  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.Song_Title) || "",

      artist: (contactEdit && contactEdit.Song_Artist) || "",
 
      duration: (contactEdit && contactEdit.Song_Duration) || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().trim().required("Şarkı adını giriniz"),
      artist: Yup.string().trim().required("Sanatçıyı giriniz"),
      duration: Yup.string().trim().nullable(),
    }),
    onSubmit: values => {
      // Kategori formik disinda tutuluyor; secilmezse sarki hicbir listede gorunmez
      if (!getCategoryID) {
        toastWarning("Lütfen bir şarkı kategorisi seçiniz.");
        return;
      }
      if (!getFileNameSecond) {
        toastWarning("Lütfen bir ses dosyası (mp3) yükleyiniz.");
        return;
      }

      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          Song_Title: values.title,
          Song_Category_ID: getCategoryID,
          Song_Artist:values.artist,
          Song_Duration:values.duration,
         
          Song_Image:getFileName,
          Song_Link:getFileNameSecond,
        };
        dispatch(onUpdateSong(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          Song_Title: values["title"],
          Song_Artist: values["artist"],
          Song_Duration: values["duration"],
          Song_Category_ID: getCategoryID,
          Song_Link:getFileNameSecond,
          Song_Image:getFileName
        };
        // save new user
        dispatch(onAddSong(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.song,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);


  const [getCategoryID, setCategoryID] = useState(null);


  const [getCategory, setCategory] = useState([]);



// Sarki satirlari: yoneticinin listeden cikmadan dinleyebilmesi icin
  // ses onizlemesi de eklendi.
  const columns = useMemo(
    () => [
      {
        Header: "Kapak",
        accessor: "Song_Image",
        disableFilters: true,
        disableSortBy: true,
        Cell: cellProps => {
          const row = cellProps.row.original;
          const src = mediaUrl(row.Song_Image);
          return src ? (
            <img
              src={src}
              alt=""
              style={{
                width: 48,
                height: 48,
                objectFit: "cover",
                borderRadius: 8,
              }}
            />
          ) : (
            <div className="avatar-sm">
              <span className="avatar-title rounded bg-light text-muted">
                {stripHtml(row.Song_Title).charAt(0) || "?"}
              </span>
            </div>
          );
        },
      },

      {
        Header: "Şarkı",
        accessor: "Song_Title",
        filterable: true,
        Cell: cellProps => {
          const row = cellProps.row.original;
          return (
            <div style={{ minWidth: 160 }}>
              <div className="fw-bold">
                {stripHtml(row.Song_Title) || <em>İsimsiz</em>}
              </div>
              <div className="text-muted font-size-12">
                {stripHtml(row.Song_Artist) || "Sanatçı girilmemiş"}
              </div>
            </div>
          );
        },
      },

      {
        Header: "Kategori",
        accessor: "Song_Category.Song_Category_Text",
        filterable: true,
        Cell: cellProps => (
          <span className="badge badge-soft-primary font-size-12">
            {cellProps.value || "Kategorisiz"}
          </span>
        ),
      },

      {
        Header: "Süre",
        accessor: "Song_Duration",
        filterable: true,
        Cell: cellProps => (
          <span className="text-muted">{cellProps.value || "-"}</span>
        ),
      },

      {
        Header: "Ses",
        accessor: "Song_Link",
        disableFilters: true,
        disableSortBy: true,
        Cell: cellProps => {
          const src = mediaUrl(cellProps.value);
          if (!src) {
            return (
              <span className="badge badge-soft-danger font-size-11">
                Ses dosyası yok
              </span>
            );
          }
          return (
            <audio controls preload="none" style={{ height: 32, width: 190 }}>
              <source src={src} />
            </audio>
          );
        },
      },

      {
        Header: "İşlemler",
        disableFilters: true,
        disableSortBy: true,
        Cell: cellProps => {
          const row = cellProps.row.original;
          const editId = `song-edit-${row.ID}`;
          const deleteId = `song-delete-${row.ID}`;
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => handleUserClick(row)}
              >
                <i className="mdi mdi-pencil font-size-18" id={editId} />
                <UncontrolledTooltip placement="top" target={editId}>
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => onClickDelete(row)}
              >
                <i className="mdi mdi-delete font-size-18" id={deleteId} />
                <UncontrolledTooltip placement="top" target={deleteId}>
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  const _getAuthData = async () => {

    await axios.get(`${ODATA_BASE}/Song_Category`)
      .then((res) => {
        setCategory(res.data.value || [])
      })
  }

  useEffect(() => {
    _getAuthData()
    if (users && !users.length) {
      dispatch(onGetSong());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };


  const handleUserClickMedia = (arg) => {
    const user = arg;

    setSubMediaID(user.ID)

    setFileSubMedia(user.EducationSubItem_Media)

    toggleMedia();
  };


const handleUserClick = (arg) => {
    const user = arg;
    setEditContact(user);
    setCategoryID(user.Song_Category_ID);

    // Mevcut dosyalar state'e alinmazsa kaydet'te Song_Image/Song_Link bosaltiliyor
    setFileName(user.Song_Image || '');
    setFileNameSecond(user.Song_Link || '');
    
    // Eğer veritabanında şarkı için bir açıklama alanı varsa (örn: Song_Description) buraya ekle:
    setHtmlDataLong(user.Song_Description || ""); 
    
    setIsEdit(true);
    toggle();
  };

  

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };
  // NOT: burada `setContact(<liste>)` çağıran iki useEffect vardı.
  // `contact` SEÇİLİ SATIRI tutuyor; liste her değiştiğinde tüm dizi ile
  // eziliyor, dizide `.ID` olmadığı için silme sessizce hiçbir şey yapmıyordu.

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteSong(contact.ID));
    }
    setContact(undefined);
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    // onceki duzenlemeden kalan dosya/kategori bilgisi yeni kayda sizmasin
    setEditContact(undefined);
    setFileName('');
    setFileNameSecond('');
    setCategoryID(null);
    setHtmlDataLong('');
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }

  const _addMedia = () => {


    getFileSubMediaAdd.map((item, index) => {
      const newUser = {
        Education_SubItem_ID: getSubMediaID,
        EducationSubItem_Media_Type: item.fileType,
        EducationSubItem_Media_Link: item.fileName
      }

      axios.post(API_BASE + '/addSubEducationMediaDiz/send', newUser)

      dispatch(onGetSong());

      toggleMedia();
    })
  }

  // Gorseller yuklenmeden once kucultulur (bkz. helpers/gorselKucult.js)
  const getUploadParams = gorselYuklemeParametreleri

  const handleChangeStatusBanner = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response)
          console.log("lnslkdf", result.file)
          setFileSubMediaAdd(oldArray => [{ fileName: result.file.filename, fileType: result.file.mimetype }, ...oldArray]);
        }
      }
    }
  }
  const handleChangeStatus = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)

        }
      }
    }
  }

  // NOT: burada setFileName cagriliyordu; mp3 yuklemek gorseli eziyor ve
  // Song_Link her zaman bos gidiyordu (sarki hic calmiyordu).
  const handleChangeStatusSecond = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNameSecond(result.file.filename)
        }
      }
    }
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="ŞARKI Listesi" />
          <SayfaRehberi sayfa="song" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddSong={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={modalMedia} toggle={toggleMedia}>
                    <ModalHeader toggle={toggleMedia} tag="h4">
                      {!!isEdit ? "Düzenle" : "Medya Ekle"}
                    </ModalHeader>
                    <ModalBody>

                      <Row>
                        <Col xs={12}>


                          <div className="mb-3">
                            <label htmlFor="resume">Görsel</label>
                            <Dropzone
                              maxFiles={5}
                              getUploadParams={getUploadParams}
                              multiple={true}
                              onChangeStatus={handleChangeStatusBanner}
                              styles={{
                                dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                inputLabelWithFiles: { margin: '20px 3%' }
                              }}
                              canRemove={true}
                              PreviewComponent={Preview}
                              accept="image/*,video/*"
                            />
                          </div>

                        </Col>
                      </Row>
                      <Row>

                        {getFileSubMedia.map((item, index) => (
                          item.EducationSubItem_Media_Type == "video/mp4" ?
                            <div key={index}>
                              <video width="150" height="150" controls>
                                <source src={'https://megasubdomain.stechomeyazilim.info/' + item.EducationSubItem_Media_Link} type="video/mp4" />
                              </video>

                            </div> :

                            <div key={index}>
                              <img src={'https://megasubdomain.stechomeyazilim.info/' + item.EducationSubItem_Media_Link} alt="" className="avatar-sm" />
                            </div>
                        ))}



                        <Col>
                          <div className="text-end">
                            <button
                              onClick={() => _addMedia()}
                              type="submit"
                              className="btn btn-success save-user"
                            >
                              Medyaları Kaydet
                            </button>
                          </div>
                        </Col>
                      </Row>

                    </ModalBody>
                  </Modal>

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Şarkı Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>

                          <div className="mb-3">
                              <Label className="form-label">Şarkı Kategori Seçiniz</Label>
                              <Input
                                
                                type="select"
                                className="form-select"
                                defaultValue={getCategoryID}
                                onChange={(text) => _setChoiceCategory(text)}
                                value={
                                  getCategoryID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getCategory.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Song_Category_Text}</option>
                                ))}

                              </Input>
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Şarkı Başlığını Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">Artist</Label>
                              <Input
                                name="artist"
                                label="artist"
                                type="text"
                                placeholder="Artist Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.artist || ""}
                                invalid={
                                  validation.touched.artist &&
                                    validation.errors.artist
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.artist &&
                                validation.errors.artist ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.artist}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Şarkı Süresi</Label>
                              <Input
                                name="duration"
                                label="duration"
                                type="text"
                                placeholder="Şarkı süresi Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.duration || ""}
                                invalid={
                                  validation.touched.duration &&
                                    validation.errors.duration
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.duration &&
                                validation.errors.duration ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.duration}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Col xs={12} className="mb-3">
                                <label htmlFor="resume">Görsel</label>
                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatus}
                                  styles={{
                                    dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}

                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="image/*"
                                />

                              </Col>
                            </div>

                            <div className="mb-3">
                              <Col xs={12} className="mb-3">
                                <label htmlFor="resume">Şarkı</label>
                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatusSecond}
                                  styles={{
                                    dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}

                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="audio/*"
                                />

                              </Col>
                            </div>

                   

                     <div className="mb-3">
  <Label className="form-label">Uzun Açıklama</Label>
  <CustomEditor
    data={getHtmlDataLong}
    onChange={(newData) => setHtmlDataLong(newData)}
  />
</div>

                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
